import { render, staticRenderFns } from "./UrbanTerzoneRegulationList.vue?vue&type=template&id=a0ddd72a&"
import script from "./UrbanTerzoneRegulationList.vue?vue&type=script&lang=js&"
export * from "./UrbanTerzoneRegulationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports